import { getTimeRange } from '../../../../../../constants/helpers/dates';

import { AirtimeReportCreateForm } from './interfaces';

export const mapTableDataIntoApiFormat = (report: AirtimeReportCreateForm) => ({
  name: report.name,
  metadata: {
    timeRange: getTimeRange({ from: report.from, to: report.to }),
    skus: report.skus,
    statuses: report.statuses,
    operators: report.operators,
    operationIds: report.operationIds,
    acquirerMsisdns: report.acquirerMsisdns
  }
});
